// extracted by mini-css-extract-plugin
export var container = "contact-module--container--RQdWU";
export var containerLeft = "contact-module--containerLeft--JRt56";
export var containerList = "contact-module--containerList--VipHI";
export var containerRight = "contact-module--containerRight--p+dCP";
export var containerSubtitle = "contact-module--containerSubtitle--ui2Sa";
export var containerText = "contact-module--containerText--BrO58";